export default {
    data: function() {
        return {
            
            persianNumbers : [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers  : [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
        }
    },
    computed: {

    },
    mounted() {

    },
    created() {
       
    },
    methods: {
        fixNumbers(str){
          if(typeof str === 'string')
          {
            for(var i=0; i<str.length; i++)
            {
              str = str.replace(this.persianNumbers[i], i).replace(this.arabicNumbers[i], i);
            }
          }
          return str;
        }
    }
};